import React from 'react';
import Tabs from '@amzn/awsui-components-core/tabs';
import { WbrViewTab } from 'src/types';

interface DashboardTabsProps {
  tabs: WbrViewTab[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
}

export const DashboardTabs: React.FC<DashboardTabsProps> = ({ tabs, activeTabId, onTabChange }) => {
  return (
    <div className="dashboard-tabs-nav-only">
      <Tabs
        activeTabId={activeTabId}
        onChange={({ detail }) => onTabChange(detail.activeTabId)}
        tabs={tabs.map((t) => ({
          id: t.id,
          label: t.label,
          content: null,
        }))}
      />
    </div>
  );
};
